import { useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface UseDeleteIssueSubtypeParams {
  onError?: (error: ExtendedAxiosError) => void;
}

export function useDeleteIssueSubtype({
  onError,
}: UseDeleteIssueSubtypeParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<void, ExtendedAxiosError, string>({
    mutationKey: ['issue-subtypes'],
    mutationFn: (id) =>
      api.issueSubtypesApi.deleteIssueSubtype(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['users', 'roles'],
      });
    },
    onError,
  });
}
